import React, { memo } from 'react';
import { useLangFile } from '../../../../context/LanguageContext';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { ArrowBack } from '@mui/icons-material';

interface NavigateToPreviousFieldButtonProps {
  onBulkFieldChange: () => void;
  isDisabled: boolean;
}

const NavigateToPreviousFieldButton: React.FC<NavigateToPreviousFieldButtonProps> = (
  props: NavigateToPreviousFieldButtonProps
) => {
  const LangFile = useLangFile();

  return (
    <Tooltip title={LangFile.PrescriptionToolbar.previousField}>
      <Box
        sx={{
          mr: 1,
          ml: 1,
        }}
      >
        <Button
          data-testid="bulk-previous-field"
          variant={'contained'}
          color={'primary'}
          onClick={() => props.onBulkFieldChange()}
          disabled={props.isDisabled}
        >
          <ArrowBack />
          <Box
            sx={{
              ml: 1,
            }}
          >
            {LangFile.PrescriptionToolbar.previousField}
          </Box>
        </Button>
      </Box>
    </Tooltip>
  );
};

export default memo(NavigateToPreviousFieldButton);
